import { FunctionComponent, ClipboardEvent as ReactClipboardEvent } from 'react';
import { Text } from '@tocktix/pantry';

const EM_DASH = '\u2014';

type EmailValueProps = {
  value?: string | null;
};

/**
 * Renders an email value that copies cleanly on a normal Cmd/Ctrl+C.
 *
 * Copying via text selection serializes the laid-out DOM: a block <p> (or a
 * flex-item <span>) makes the browser append a structural newline, producing
 * "email\n" (or "email\n\n"). Strict email inputs (e.g. resy web) reject that
 * trailing newline. The onCopy handler intercepts the copy and writes the exact
 * string instead, so no copy button or clipboard permission prompt is needed.
 */
const EmailValue: FunctionComponent<EmailValueProps> = ({ value }) => {
  if (!value) {
    return <Text variant="body">{EM_DASH}</Text>;
  }
  return (
    <Text
      as="span"
      variant="body"
      onCopy={(e: ReactClipboardEvent) => {
        e.preventDefault();
        e.clipboardData.setData('text/plain', value);
      }}
    >
      {value}
    </Text>
  );
};

export default EmailValue;
